




























import {
  defineComponent,
  reactive,
  computed,
  PropType,
  useContext,
} from '@nuxtjs/composition-api'
import RgsListItem from '@/components/RgsListItem.vue'
import RgsCardItem from '@/components/RgsCardItem.vue'
import { YmUnit } from '@/contracts/Ym'

export default defineComponent({
  name: 'NavigationLink',
  components: { RgsCardItem, RgsListItem },
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    rel: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: () => {},
    },
    svgIcon: {
      type: String,
      default: '',
    },
    ymEvent: {
      type: Object as PropType<YmUnit> | null,
      default: null,
    },
  },
  setup(props) {
    const ctx = useContext()
    const YM_ID = ctx.$config.YM_ID
    const isNuxtLink =
      !!props.link &&
      !(props.link.startsWith('http') || props.link.startsWith('https'))
    const linkComponent = computed(() => {
      if (isNuxtLink) return 'NuxtLink'
      if (props.link) return 'a'
      return 'div'
    })
    const linkProps = reactive({
      rel: props.rel,
      target: props.target,
      [isNuxtLink ? 'to' : 'href']: props.link,
    })
    if (props.ymEvent) {
      linkProps.onmousedown = `ym(${props.ymEvent.ymId || YM_ID}, '${
        props.ymEvent.ymMethod
      }', '${props.ymEvent.ymTarget}'); return true;`
    }
    return {
      linkComponent,
      linkProps,
    }
  },
})
